import React from 'react';
import styled from 'styled-components';
import PropTypes from 'prop-types';

import { Box, Text, Media } from './Boneyard';
import { useSSRQuery } from '../graphql';
import { FLIGHT_PROVIDER_LABEL } from '../../automationHooks';

import OPERATOR_LOGOS_QUERY from '../pageComponents/indexPage/operatorLogos.query.graphql.js';

const FlightOperatorLogo = styled(Box)`
  align-self: center;
  flex-basis: 100%;

  ${/* sc-selector */ Text} {
    max-width: 100%;
    display: ${props => props.display};
    align-items: center;
    gap: 3px;
  }

  ${props => props.theme.query.lg} {
    ${/* sc-selector */ Text} {
      width: 160px;
    }
  }
`;

const OperatedByLogo = styled.img`
  height: 14px;
  margin: ${props => props.margin};
  position: ${props => props.position};
`;

const propTypes = {
  operatedBy: PropTypes.object,
  operatedByLabel: PropTypes.string,
  display: PropTypes.string,
  weight: PropTypes.number,
  sizeMd: PropTypes.number,
  sizeSm: PropTypes.number,
  margin: PropTypes.string,
  position: PropTypes.string,
};

const FlightOperator = ({
  operatedBy,
  operatedByLabel,
  display,
  weight,
  sizeMd = 14,
  sizeSm = 11,
  margin = '',
  position = '',
}) => {
  const { data: carrierLogo } = useSSRQuery(OPERATOR_LOGOS_QUERY);
  const operatedByLogo = carrierLogo?.application?.images?.find(
    image => image.id === operatedBy?.carrier
  );
  return (
    <FlightOperatorLogo display={display} pt={1}>
      <Media>
        {mq => (
          <Text
            size={mq.lt('md') ? sizeSm : sizeMd}
            weight={weight}
            automationHook={FLIGHT_PROVIDER_LABEL.hook}
          >
            {operatedByLabel + ' '}
            <OperatedByLogo
              margin={margin}
              position={position}
              src={operatedByLogo?.path}
            />
          </Text>
        )}
      </Media>
    </FlightOperatorLogo>
  );
};

FlightOperator.propTypes = propTypes;
export default FlightOperator;
